export default __webpack_public_path__ + "static/media/mustard-yellow-2-designify.e70679b8.png";